import { useController } from "react-hook-form";
import { Stack, TextInput } from "@mantine/core";
import { FormErrorBox } from "@/components/ui/FormErrorBox/FormErrorBox";
import type { Control } from "react-hook-form";

export function OtherTextInput({
  name,
  control,
  disabled,
}: {
  name: string;
  control: Control<any>;
  disabled?: boolean;
}) {
  const { field, fieldState } = useController({ name, control, defaultValue: "" });
  return (
    <Stack gap={4} style={{ flex: 1 }}>
      <TextInput
        placeholder="Please specify..."
        disabled={disabled}
        value={field.value as string}
        onChange={field.onChange}
        size="sm"
        error={!!fieldState.error}
      />
      {fieldState.error?.message && <FormErrorBox message={fieldState.error.message} />}
    </Stack>
  );
}
